
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle, ExternalLink } from "lucide-react";

interface RequestItem {
  id: string;
  merchant: string;
  amount: string;
  status: string;
  date: string;
}

interface RequestsTableProps {
  requests: RequestItem[];
  emptyMessage: string;
  createNewLabel?: string;
}

export function RequestsTable({ requests, emptyMessage, createNewLabel }: RequestsTableProps) {
  if (requests.length === 0) {
    return (
      <div className="text-center py-10 bg-gray-50 rounded-lg border border-dashed">
        <p className="text-muted-foreground mb-4">{emptyMessage}</p>
        {createNewLabel && (
          <Button asChild>
            <Link to="/refund">
              <PlusCircle className="mr-2 h-4 w-4" />
              {createNewLabel}
            </Link>
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="rounded-lg border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left font-medium">Seller</th>
              <th className="px-4 py-3 text-left font-medium">Amount</th>
              <th className="px-4 py-3 text-left font-medium">Status</th>
              <th className="px-4 py-3 text-left font-medium">Date</th>
              <th className="px-4 py-3 text-right font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.id} className="border-t hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 font-medium">{request.merchant}</td>
                <td className="px-4 py-3">{request.amount}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
                    request.status === "Refunded" || request.status === "Approved"
                      ? "bg-green-100 text-green-800 border-green-200" 
                      : request.status === "Rejected" || request.status === "Denied"
                        ? "bg-red-100 text-red-800 border-red-200"
                        : "bg-yellow-100 text-yellow-800 border-yellow-200"
                  }`}>
                    {request.status}
                  </span>
                </td>
                <td className="px-4 py-3">{request.date}</td>
                <td className="px-4 py-3 text-right">
                  <Button asChild size="sm" variant="outline">
                    <Link to={`/conversation/${request.id}`} className="flex items-center">
                      View <ExternalLink className="ml-1 h-3 w-3" />
                    </Link>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
